(() => {
  const form = document.getElementById('af-form');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const config = JSON.parse(document.getElementById('af-config').textContent);
  const $ = s => form.querySelector(s);
  const all = s => [...form.querySelectorAll(s)];
  const answers = {};
  const enquiryParams = new URLSearchParams(location.search);
  let vehicle = null;
  let current = 'asset';
  let advancing = false;
  const money = n => new Intl.NumberFormat('en-AU', {style:'currency',currency:'AUD',maximumFractionDigits:0}).format(n);
  const sequence = () => ['asset', ...(answers.asset === 'Personal loan' ? [] : ['condition']), 'numbers', 'employment', ...(answers.employment === 'Centrelink' ? [] : ['length']), 'income','living','contact','verify'];
  const amount = $('#af-amount'), deposit = $('#af-deposit'), term = $('#af-term');
  const estimate = () => {
    deposit.max = Number(amount.value) - 500;
    deposit.value = Math.min(Number(deposit.value), Number(deposit.max));
    const principal = Number(amount.value) - Number(deposit.value);
    const r = 0.0799 / 12, n = Number(term.value) * 12;
    const monthly = principal * r / (1 - Math.pow(1 + r, -n));
    $('#af-amount-out').textContent = money(amount.value);
    $('#af-deposit-out').textContent = money(deposit.value);
    $('#af-term-out').textContent = term.value + ' ' + config.years;
    $('#af-payment').textContent = money(monthly * 12 / 52) + ' ' + config.week;
    $('#af-financed').textContent = config.financed + ': ' + money(principal);
    all('.af-range').forEach(range => {
      const input = range.querySelector('input');
      range.querySelector('.af-limits span:last-child').textContent = input === term ? config.sevenYears : money(input.max);
    });
    return principal;
  };
  [amount,deposit,term].forEach(input => input.addEventListener('input',estimate));
  function contactValid() {
    return all('[data-step="contact"] .af-fields input').every(input => input.name === 'phone' ? /^(04\d{8}|\+614\d{8}|614\d{8})$/.test(input.value.replace(/[\s()-]/g,'')) : input.value.trim() && input.checkValidity());
  }
  function show(key, focus=true) {
    current = key;
    all('.af-step').forEach(step => step.hidden = step.dataset.step !== key);
    const seq = sequence(), index = seq.indexOf(key);
    $('#af-counter').textContent = config.step + ' ' + (index+1) + ' / ' + seq.length;
    $('#af-back').hidden = index === 0;
    const progress = Math.round((index+1) / seq.length * 100);
    $('#af-bar').style.width = progress + '%';
    $('.af-progress').setAttribute('aria-valuenow',progress);
    if (key === 'review') renderSummary();
    if (focus) {
      const heading = $('[data-step="'+key+'"] h2');
      heading.focus({preventScroll:true});
      form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    }
  }
  function renderSummary() {
    const values = {...answers,vehicle:vehicle?.title,vehicle_stock:vehicle?.stock,vehicle_price:vehicle ? money(vehicle.price) : '', amount:money(amount.value),deposit:money(deposit.value),financed:money(estimate()),term:term.value+' '+config.years};
    all('[data-step="contact"] .af-fields input').forEach(input => values[input.name] = input.value.trim());
    const summary = $('#af-summary'); summary.replaceChildren();
    const labels = {...config.labels,vehicle:'Selected vehicle',vehicle_stock:'Stock number',vehicle_price:'Vehicle price'};
    Object.keys(labels).forEach(key => {
      if (!values[key]) return;
      const row = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = labels[key]; dd.textContent = values[key];
      row.append(dt,dd); summary.append(row);
    });
  }
  all('.af-option').forEach(button => button.addEventListener('click',() => {
    if (advancing) return;
    const field = button.dataset.field;
    answers[field] = button.dataset.value;
    if (field === 'asset' && vehicle && answers.asset !== 'Car') clearVehicle();
    if (field === 'asset' && answers.asset === 'Personal loan') delete answers.condition;
    if (field === 'employment' && answers.employment === 'Centrelink') delete answers.length;
    all('[data-field="'+field+'"]').forEach(b => b.setAttribute('aria-pressed',b===button?'true':'false'));
    advancing = true;
    window.setTimeout(() => {
      const seq = sequence(); show(seq[seq.indexOf(current)+1]); advancing = false;
    },220);
  }));
  $('#af-numbers-continue').addEventListener('click',() => {
    estimate(); show('employment');
  });
  $('#af-back').addEventListener('click',() => {
    if(advancing)return;
    const seq = sequence(); show(seq[Math.max(0,seq.indexOf(current)-1)]);
  });
  function continueContact() {
    if(contactValid()){
      if(!$('[name="consent"]').checked||!$('[name="contact_consent"]').checked||!$('[name="sms_consent"]').checked){$('#af-review-error').textContent='Please accept the privacy, contact and SMS verification consents to continue.';return;}
      $('#af-review-error').textContent='';show('verify');$('aaf-sms-verification')?.beginVerification?.();return;
    }
    const invalid=all('[data-step="contact"] .af-fields input').find(input=>{
      if(input.name==='phone')return !/^(04\d{8}|\+614\d{8}|614\d{8})$/.test(input.value.replace(/[\s()-]/g,''));
      return !input.value.trim()||!input.checkValidity();
    });
    if(invalid){invalid.focus();invalid.reportValidity();}
  }
  $('#af-contact-continue').addEventListener('click',continueContact);
  form.addEventListener('keydown',e=>{
    if(e.key==='Enter'&&current==='contact'){e.preventDefault();continueContact();}
  });
  let submitting=false;
  form.addEventListener('submit',async e => {
    e.preventDefault();
    if(submitting||current!=='verify'||!contactValid()||!$('[name="consent"]').checked||!$('[name="contact_consent"]').checked)return;
    const sms=$('aaf-sms-verification');
    if(!sms?.isVerified?.()){$('#af-submit-error').textContent=config.verifyError;return;}
    const input=Object.fromEntries(all('[data-step="contact"] .af-fields input').map(i=>[i.name,i.value.trim()]));
    const submittedAt=new Date().toISOString();
    const payload={...answers,form_name:'Finance Application',lead_source:'Website finance form',first_name:input.firstname,last_name:input.lastname,email:input.email,phone:sms.number(),loan_amount:estimate(),amount_before_deposit:Number(amount.value),deposit:Number(deposit.value),loan_term:Number(term.value),employment_status:answers.employment,employment_length:answers.length||'',monthly_income_range:answers.income,living_situation:answers.living,consent:'Yes',privacy_consent:true,privacy_accepted_at:submittedAt,privacy_document_version:config.privacyVersion,privacy_document_sha256:config.privacyHash,mobile_verified:true,mobile_verification_reference:sms.reference.value,page_url:location.href,page_title:document.title,submitted_at:submittedAt,referrer:document.referrer};
    if(vehicle)Object.assign(payload,{vehicle:vehicle.title,vehicle_title:vehicle.title,vehicle_url:vehicle.url,vehicle_price:vehicle.price,vehicle_stock:vehicle.stock,vehicle_product_id:vehicle.id,vehicle_handle:vehicle.handle});
    const params=new URLSearchParams(location.search);['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid'].forEach(k=>{if(params.has(k))payload[k]=params.get(k);});
    payload.notes=Object.entries({...answers,...(vehicle?{vehicle:vehicle.title,vehicle_stock:vehicle.stock,vehicle_url:vehicle.url,vehicle_price:vehicle.price,vehicle_product_id:vehicle.id}:{})}).map(([k,v])=>k+': '+v).join('\n');
    const button=$('[type="submit"]'),label=button.textContent;
    submitting=true;button.disabled=true;button.textContent=config.sending;$('#af-submit-error').textContent='';
    try{
      if(!config.webhook)throw Error();
      const response=await fetch(config.webhook,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload)});
      if(!response.ok)throw Error();
      all('.af-step').forEach(step=>step.hidden=true);$('#af-complete').hidden=false;$('#af-back').hidden=true;
      if(typeof window.fbq==='function')window.fbq('track','Lead');
      window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'finance_application_submitted'});
    }catch(error){$('#af-submit-error').textContent=config.submitError;button.disabled=false;button.textContent=label;submitting=false;}
  });
  function clearVehicle() {
    vehicle=null; $('#af-vehicle').hidden=true;
  }
  $('#af-vehicle-clear')?.addEventListener('click',()=>{clearVehicle();show('asset');});
  function renderVehicle() {
    $('#af-vehicle').hidden=false;
    $('#af-vehicle-title').textContent=vehicle.title;
    $('#af-vehicle-details').textContent=money(vehicle.price)+(vehicle.stock?' · Stock #'+vehicle.stock:'');
    $('#af-vehicle-link').href=vehicle.url;
    if(vehicle.image){$('#af-vehicle-image').src=vehicle.image;$('#af-vehicle-image').alt=vehicle.title;$('#af-vehicle-image').hidden=false;}
  }
  const requestedAmount=Number(enquiryParams.get('loan_amount'));
  if(Number.isFinite(requestedAmount)&&requestedAmount>0){
    amount.step='1';amount.min=Math.min(5000,requestedAmount);amount.max=Math.max(150000,requestedAmount);amount.value=requestedAmount;
  }
  estimate();show('asset',false);
  // Resolve the selected product against the public Shopify catalogue.
  const productPath=enquiryParams.get('vehicle_url');
  if(productPath && /^\/products\/[a-zA-Z0-9-]+$/.test(productPath)){
    vehicle={title:enquiryParams.get('vehicle')||'Selected vehicle',url:productPath,price:Number(enquiryParams.get('vehicle_price'))||requestedAmount||30000,stock:enquiryParams.get('vehicle_stock')||'',id:'',handle:productPath.split('/').pop()};
    answers.asset='Car';$('[data-field="asset"][data-value="Car"]').setAttribute('aria-pressed','true');
    renderVehicle();show('condition',false);
    const selectedVehicle=vehicle;
    fetch(productPath+'.js',{credentials:'same-origin'}).then(response=>{if(!response.ok)throw Error();return response.json();}).then(product=>{
      if(vehicle!==selectedVehicle)return;
      vehicle.title=product.title;vehicle.id=String(product.id);vehicle.handle=product.handle;
      vehicle.price=Number(product.price)/100;vehicle.stock=vehicle.stock||product.variants?.find(v=>v.sku)?.sku||'';
      vehicle.image=product.featured_image||product.images?.[0]||'';
      renderVehicle();
      // Keep an amount the applicant has already edited.
      if(Number(amount.value)===requestedAmount){amount.max=Math.max(150000,vehicle.price);amount.min=Math.min(5000,vehicle.price);amount.value=vehicle.price;estimate();}
    }).catch(()=>{/* Keep the vehicle details supplied by the enquiry link. */});
  }
})();

